/**
 * The famous Observer pattern as a Javascript class
 */
export default class Observer {
  listeners = []
  notified = false

  /**
   * Method that subscribe to the observer and returns an unsubscriber
   * @param {Function} listener - the function to be called when the observer is notified
   * @returns {Function} - an unsubscriber
   */
  subscribe(listener) {
    this.listeners.push(listener)
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener)
    }
  }

  /**
   * Methods that notify all depending listeners and prevent notifying itself
   * @param  {...any} args
   */
  notify(...args) {
    if (!this.notified) {
      this.notified = true
      this.listeners.forEach(listener => listener(...args))
      this.notified = false
    }
  }
}
